export const formatDate = (value: any) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);

  return date.toLocaleDateString('en-GB');
};
